var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2 10.2178C19.2 9.53825 19.139 8.88484 19.0258 8.25757H10V11.9646H15.1576C14.9354 13.1625 14.2602 14.1775 13.2453 14.857V17.2615H16.3424C18.1545 15.5932 19.2 13.1364 19.2 10.2178Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 19.5831C12.5876 19.5831 14.7569 18.7249 16.3425 17.2613L13.2453 14.8567C12.3872 15.4317 11.2894 15.7715 10.0001 15.7715C7.50403 15.7715 5.39134 14.0857 4.63774 11.8206H1.43604V14.3035C3.01293 17.4355 6.25384 19.5831 10.0001 19.5831Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.63777 11.8207C4.4461 11.2457 4.3372 10.6315 4.3372 9.99983C4.3372 9.3682 4.4461 8.754 4.63777 8.179V5.69604H1.43607C0.787013 6.98979 0.416748 8.45343 0.416748 9.99983C0.416748 11.5462 0.787013 13.0099 1.43607 14.3036L4.63777 11.8207Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 4.22806C11.4071 4.22806 12.6703 4.71158 13.6635 5.6612L16.4122 2.91253C14.7525 1.36613 12.5832 0.416504 10.0001 0.416504C6.25384 0.416504 3.01293 2.56404 1.43604 5.69605L4.63774 8.179C5.39134 5.91385 7.50403 4.22806 10.0001 4.22806Z",
    fill: "#EA4335"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogoIcon);
export default __webpack_public_path__ + "static/media/GoogleLogoIcon.97b3745629598df6acb560762709e9e6.svg";
export { ForwardRef as ReactComponent };